import request from '@/api/request';
import WebComponents from '@3vjia/v-web-comp-vue';
import '@3vjia/v-web-comp-vue/dist/vWebComp.css';

const webComp = new WebComponents({
  request,
  mode: process.env.VUE_APP_MODE,
  baseUrl: { // 暂时先这样写，后续插件更新再修改
    test: process.env.VUE_APP_AIHOUSEURL,
    prod: process.env.VUE_APP_AIHOUSEURL,
    pre: process.env.VUE_APP_AIHOUSEURL,
    dev: process.env.VUE_APP_AIHOUSEURL,
  },
  components: ['footer'],
  path: 'outerFooter',
});
export default function installLayout() {
  webComp.installComponents([
    {
      name: 'footer',
    },
  ]);
}
